// Date formatting utilities

/**
 * Format date from yyyy-mm-dd to dd-mm-yyyy
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

/**
 * Format date range
 */
export const formatDateRange = (startDate, endDate) => {
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};

/**
 * Get Danish month name
 */
export const getDanishMonth = (monthNum) => {
  const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 
                  'juli', 'august', 'september', 'oktober', 'november', 'december'];
  return months[parseInt(monthNum) - 1] || '';
};

/**
 * Format date to Danish format (e.g., "15. marts 2025")
 */
export const formatDateDanish = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const day = parseInt(parts[2]);
  const month = getDanishMonth(parts[1]);
  const year = parts[0];
  return `${day}. ${month} ${year}`;
};
